/// <reference path="../../_ext/Bases/GridBase.ts" />

namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnMasterGrid extends _Ext.GridBase<PurchaseReturnMasterRow,any > {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnMaster'; }
        protected getDialogType() { return PurchaseReturnMasterDialog; }
        protected getIdProperty() { return PurchaseReturnMasterRow.idProperty; }
        protected getInsertPermission() { return PurchaseReturnMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseReturnMasterRow.localTextPrefix; }
        protected getService() { return PurchaseReturnMasterService.baseUrl; }
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {
            
            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[14].AutoPosting;
            var voucherNo = FormatHelper.GetVoucherNo(14);
            
            this.editItem(<PurchaseReturnMasterRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId, 
                VoucherTypeId:14,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}